var map = {
	"./DC-Logo-Web-Black-StackedTagline.png": 1158,
	"./DC-Logo-Web-Color-StackedTagline.png": 1159,
	"./DC-Logo-Web-Color.png": 1160,
	"./DC-Logo-Web-White-StackedTagline.png": 1161,
	"./DC-Logo-Web-White.png": 1162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1157;